export default class HoverMap {
	constructor() {
		this.init();
	}

	init() {
		let triggers = document.querySelectorAll('[data-map-trigger]');

		triggers.forEach( (element) => {
			element.addEventListener( 'mouseover', event => {
				let id = element.getAttribute('data-map-trigger');
				let target = document.querySelector('[data-map-target="' + id + '"]');
				target.classList.add('visible');

				console.log(id);
			} );

			element.addEventListener( 'mouseout', event => {
				let id = element.getAttribute('data-map-trigger');
				let target = document.querySelector('[data-map-target="' + id + '"]');
				target.classList.remove('visible');

				console.log(id);
			} );
		} );
	}
}